import { createSelector } from 'reselect';

export const getSepaAgreementList = state => state.client.sepaAgreement.list;

export const hasSepaAgreement = clientId =>
  createSelector(getSepaAgreementList, list =>
    list.filter(({ target, is_active }) => target === clientId && is_active)
  );

export default {
  hasSepaAgreement,
};
